function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/* eslint-disable react-hooks/exhaustive-deps */
import React, { memo } from 'react';
import { Row, Col, InputGroup, Input, Label } from 'reactstrap';
import { _translate, _Notifications } from "../../../../../../services/core";
import { useWorkFlow } from "../../../../../contexts/workflow";
import Autocomplete from "../../../../../form/autocomplete";
import { useJourney } from "../../use-utils";
import { useQuestion } from "../../../../../question/question-context";
import Icon from "../../../../../common/icon";

/**
 * Le but de cette page est d'afficher les 3 Autcomplètes pour aller
 * chercher les arrets de départ/arrivée et la ligne utilisée
 * Il faut affficher seulement pour TP. Liste à définir dans la question
 */
var Transport = function Transport(_ref) {
  var _currentQuestion$publ, _currentQuestion$publ2, _currentQuestion$publ3, _currentQuestion$publ4, _stepJourney$departur, _stepJourney$mode, _stepJourney$line, _stepJourney$mode2;
  var onChange = _ref.onChange,
    index = _ref.index,
    className = _ref.className;
  var _useWorkFlow = useWorkFlow(),
    collector = _useWorkFlow.collector;
  var currentQuestion = collector.currentQuestion;
  var _useQuestion = useQuestion(),
    _useQuestion2 = _slicedToArray(_useQuestion, 1),
    journey = _useQuestion2[0];
  var stepJourney = journey[index];
  var modeVisibleLines = (_currentQuestion$publ = currentQuestion.publicParameters) === null || _currentQuestion$publ === void 0 ? void 0 : _currentQuestion$publ.modes_lignes;
  var autocompleteAliases = (_currentQuestion$publ2 = currentQuestion.publicParameters) === null || _currentQuestion$publ2 === void 0 ? void 0 : _currentQuestion$publ2.tags;
  autocompleteAliases = autocompleteAliases ? autocompleteAliases.split(',').map(function (el) {
    return el.trim();
  }) : null;
  var tmpAutocompletrAlias = {};
  if (null !== autocompleteAliases) {
    autocompleteAliases.forEach(function (el, index) {
      tmpAutocompletrAlias["tags[".concat(index, "]")] = el;
    });
  }
  autocompleteAliases = tmpAutocompletrAlias;
  var modeTp = (_currentQuestion$publ3 = currentQuestion.publicParameters) === null || _currentQuestion$publ3 === void 0 ? void 0 : _currentQuestion$publ3.modes_tp;
  var min_character_search = ((_currentQuestion$publ4 = currentQuestion.publicParameters) === null || _currentQuestion$publ4 === void 0 ? void 0 : _currentQuestion$publ4.min_character_search) || 2;
  var handleChangePoint = function handleChangePoint(point, type) {
    if (type === 'arrival' && stepJourney !== null && stepJourney !== void 0 && stepJourney.departure && stepJourney.departure.alias === point.alias) {
      _Notifications.warning(_translate('collectorapp_title_error'), _translate('collectorapp_title_error_arrival_same_as_departure'));
      return;
    }
    onChange(point, type);
  };
  var handleLigneChange = function handleLigneChange(line) {
    onChange(line, 'line');
  };
  var reinitialize = function reinitialize() {
    if (stepJourney !== null && stepJourney !== void 0 && stepJourney.departure) {
      onChange(null, 'departure');
    }
    if (stepJourney !== null && stepJourney !== void 0 && stepJourney.arrival) {
      onChange(null, 'arrival');
    }
    if (stepJourney !== null && stepJourney !== void 0 && stepJourney.line) {
      onChange(null, 'line');
    }
  };
  if (!stepJourney || !stepJourney.mode || !modeVisibleLines || !modeTp || !modeTp.includes(stepJourney.mode.alias)) {
    reinitialize();
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "mt-3 ".concat(className),
    key: "".concat(stepJourney.mode, "_").concat(parseInt(Math.random() * 1000))
  }, /*#__PURE__*/React.createElement(Col, {
    className: "col-12 mb-3"
  }, /*#__PURE__*/React.createElement(Row, {
    className: "p-0 m-0 justify-content-lg-end"
  }, /*#__PURE__*/React.createElement(Col, {
    lg: "7",
    sm: "12",
    className: "text-center p-0 m-0  col-md-10 stop-autocomplete"
  }, /*#__PURE__*/React.createElement(Autocomplete, {
    alias: currentQuestion.alias,
    urlResource: "/autocomplete/points/".concat(currentQuestion.id),
    placeholder: _translate('collectorapp_journey_placeholder_point'),
    name: "name",
    min_character_search: min_character_search,
    resource: "GeometryPoint",
    filters: _objectSpread({
      mode: stepJourney.mode.alias,
      no_limit: true
    }, autocompleteAliases),
    tag: "name",
    display: "name",
    onChange: function onChange(a, option) {
      return handleChangePoint(option.value, 'departure');
    },
    value: stepJourney !== null && stepJourney !== void 0 && stepJourney.departure && (stepJourney === null || stepJourney === void 0 ? void 0 : stepJourney.departure) !== 'NA' ? stepJourney === null || stepJourney === void 0 ? void 0 : stepJourney.departure : null,
    disabled: (stepJourney === null || stepJourney === void 0 ? void 0 : stepJourney.departure) === 'NA',
    groupClassName: "".concat(!stepJourney.mode ? 'no-event' : '')
  }), /*#__PURE__*/React.createElement(Icon, {
    name: "edit",
    className: "edit-autoomplete color-red-wever"
  })), /*#__PURE__*/React.createElement(Col, {
    sm: "12",
    md: "2",
    className: "p-0 m-0 ml-4 d-flex align-items-center"
  }, /*#__PURE__*/React.createElement(InputGroup, {
    className: "justify-content-center label-dont-know"
  }, /*#__PURE__*/React.createElement(Label, {
    className: "m-0"
  }, /*#__PURE__*/React.createElement(Input, {
    type: "checkbox",
    name: "dont-know",
    value: (stepJourney === null || stepJourney === void 0 ? void 0 : stepJourney.departure) === 'NA',
    checked: (stepJourney === null || stepJourney === void 0 ? void 0 : stepJourney.departure) === 'NA',
    onChange: function onChange(e) {
      return handleChangePoint((stepJourney === null || stepJourney === void 0 ? void 0 : stepJourney.departure) !== 'NA' ? 'NA' : null, 'departure');
    }
  }), /*#__PURE__*/React.createElement("span", null, _translate('collectorapp_dont_know'))))))), modeVisibleLines.includes(stepJourney.mode.alias) && /*#__PURE__*/React.createElement(Col, {
    className: "col-12 mb-3"
  }, /*#__PURE__*/React.createElement(Row, {
    className: "p-0 mx-0 justify-content-lg-end"
  }, /*#__PURE__*/React.createElement(Col, {
    lg: "7",
    sm: "12",
    md: "10",
    className: "text-center p-0 m-0 "
  }, /*#__PURE__*/React.createElement(Autocomplete, {
    alias: currentQuestion.alias,
    urlResource: "/autocomplete/lines/".concat(currentQuestion.id),
    name: "line",
    resource: "GeometryLine",
    min_character_search: min_character_search,
    filters: _objectSpread(_objectSpread({
      'points[0]': stepJourney === null || stepJourney === void 0 || (_stepJourney$departur = stepJourney.departure) === null || _stepJourney$departur === void 0 ? void 0 : _stepJourney$departur.id
    }, autocompleteAliases), {}, {
      mode: stepJourney === null || stepJourney === void 0 || (_stepJourney$mode = stepJourney.mode) === null || _stepJourney$mode === void 0 ? void 0 : _stepJourney$mode.alias,
      no_limit: true
    }),
    tag: "name",
    display: "name",
    onChange: function onChange(a, option) {
      return handleLigneChange(option.value);
    },
    value: (stepJourney === null || stepJourney === void 0 ? void 0 : stepJourney.line) !== 'NA' ? stepJourney === null || stepJourney === void 0 ? void 0 : stepJourney.line : null,
    cache: false,
    autoload: true,
    disabled: (stepJourney === null || stepJourney === void 0 ? void 0 : stepJourney.line) === 'NA',
    placeholder: _translate('collectorapp_journey_placeholder_line'),
    groupClassName: "m-0 ".concat(!stepJourney.mode ? 'no-event' : '')
  })), /*#__PURE__*/React.createElement(Col, {
    sm: "12",
    md: "2",
    className: "p-0 m-0 ml-4 d-flex align-items-center"
  }, /*#__PURE__*/React.createElement(InputGroup, {
    className: "justify-content-center label-dont-know"
  }, /*#__PURE__*/React.createElement(Label, {
    className: "m-0"
  }, /*#__PURE__*/React.createElement(Input, {
    type: "checkbox",
    name: "dont-know",
    value: (stepJourney === null || stepJourney === void 0 ? void 0 : stepJourney.line) === 'dont_know',
    checked: (stepJourney === null || stepJourney === void 0 ? void 0 : stepJourney.line) === 'NA',
    onChange: function onChange(e) {
      return handleLigneChange((stepJourney === null || stepJourney === void 0 ? void 0 : stepJourney.line) !== 'NA' ? 'NA' : null);
    }
  }), /*#__PURE__*/React.createElement("span", null, _translate('collectorapp_dont_know'))))))), /*#__PURE__*/React.createElement(Col, {
    className: "col-12"
  }, /*#__PURE__*/React.createElement(Row, {
    className: "p-0 mx-0 mb-3 justify-content-lg-end"
  }, /*#__PURE__*/React.createElement(Col, {
    lg: "7",
    sm: "12",
    md: "10",
    className: "text-center p-0 m-0 stop-autocomplete"
  }, /*#__PURE__*/React.createElement(Autocomplete, {
    alias: currentQuestion.alias,
    urlResource: "/autocomplete/points/".concat(currentQuestion.id),
    placeholder: _translate('collectorapp_journey_placeholder_point_arrival'),
    name: "name",
    resource: "GeometryPoint",
    min_character_search: min_character_search,
    filters: _objectSpread({
      'lines[0]': (stepJourney === null || stepJourney === void 0 ? void 0 : stepJourney.line) !== 'NA' ? stepJourney === null || stepJourney === void 0 || (_stepJourney$line = stepJourney.line) === null || _stepJourney$line === void 0 ? void 0 : _stepJourney$line.id : null,
      mode: (_stepJourney$mode2 = stepJourney.mode) === null || _stepJourney$mode2 === void 0 ? void 0 : _stepJourney$mode2.alias,
      no_limit: true
    }, autocompleteAliases),
    tag: "name",
    display: "name",
    onChange: function onChange(a, option) {
      return handleChangePoint(option.value, 'arrival');
    },
    value: (stepJourney === null || stepJourney === void 0 ? void 0 : stepJourney.arrival) === 'NA' ? null : stepJourney === null || stepJourney === void 0 ? void 0 : stepJourney.arrival,
    cache: false,
    disabled: (stepJourney === null || stepJourney === void 0 ? void 0 : stepJourney.arrival) === 'NA',
    groupClassName: "m-0 ".concat(!stepJourney.mode ? 'no-event' : '')
  }), /*#__PURE__*/React.createElement(Icon, {
    name: "edit",
    className: "edit-autoomplete color-red-wever"
  })), /*#__PURE__*/React.createElement(Col, {
    sm: "12",
    md: "2",
    className: "p-0 m-0 ml-4 d-flex align-items-center"
  }, /*#__PURE__*/React.createElement(InputGroup, {
    className: "justify-content-center label-dont-know"
  }, /*#__PURE__*/React.createElement(Label, {
    className: "m-0"
  }, /*#__PURE__*/React.createElement(Input, {
    type: "checkbox",
    name: "dont-know",
    value: (stepJourney === null || stepJourney === void 0 ? void 0 : stepJourney.arrival) === 'NA',
    checked: (stepJourney === null || stepJourney === void 0 ? void 0 : stepJourney.arrival) === 'NA',
    onChange: function onChange(e) {
      return handleChangePoint((stepJourney === null || stepJourney === void 0 ? void 0 : stepJourney.arrival) !== 'NA' ? 'NA' : null, 'arrival');
    }
  }), /*#__PURE__*/React.createElement("span", null, _translate('collectorapp_dont_know'))))))));
};
export default /*#__PURE__*/memo(Transport);